import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { updateLatelyImage } from '../redux/latelyImageDbSlice';
import useCurrentUserId from './useCurrentUserId';
import { makeLately } from '../general';
import { ImageValueType } from '../components/ImageBrowserDialog';

const useLatelyImages = (): [string[], ImageValueType[], string] => {
  const dispatch = useDispatch();
  const userId = useCurrentUserId();
  const latelyImageDb = useSelector((state: RootState) => state.latelyImageDb);
  const imageDb = useSelector((state: RootState) => state.imageDb);
  const latelyImageId = Object.keys(latelyImageDb.latelyImages).filter(id => latelyImageDb.latelyImages[id].userId === userId)[0];

  let ids = latelyImageDb.latelyImages[latelyImageId]?.imageIds;
  const values: ImageValueType[] = [];
  let ix = 0;
  const deletedIds: string[] = [];

  if (!ids) return [ids, values, latelyImageId];

  ids.forEach(id => {
    if (Boolean(imageDb.images[id])) {
      values.push({ ...imageDb.images[id], order: ix });
      ix++;
    } else deletedIds.push(id);
  })

  if (deletedIds.length >= 1) {
    deletedIds.forEach(id => ids = makeLately(ids, id, 'delete'))
    dispatch(updateLatelyImage({ id: latelyImageId, imageIds: ids }));
  }

  return [ids, values, latelyImageId];
}

export default useLatelyImages;
